import { model as i18n } from '!/i18n'
import { combine } from 'effector'

export const $popup = combine(i18n.$t, ({ t }) => ({
  descriptionTitle: `${t('description')}:`,
  directorsTitle: `${t('directors')}:`,
  starsTitle: `${t('stars')}:`,
}))
